module.exports = __webpack_public_path__ + "img/Jump Casting15.a1781008.jpg";